import React from 'react';
import { useFormik } from 'formik';
import { CustomInput, FormGroup, Input, Label } from 'reactstrap';

const Widget3Properties = ({ properties, onChange, ...props }) => {
  const { values, setFieldValue, handleChange, ...formik } = useFormik({
    initialValues: properties,
    onSubmit: () => onChange(values),
  });
  React.useEffect(() => {
    formik.handleSubmit();
  }, [values]);
  function changeNumberValue(e, key) {
    let val = parseInt(e.target.value);
    if (Number.isNaN(val)) {
      setFieldValue(key, 1);
    } else {
      setFieldValue(key, val);
    }
  }
  return (
    <div>
      <span>Current Measurement Values</span>
      <div className="d-flex">
        <FormGroup>
          <Label>X</Label>
          <Input value={values.x} onChange={(e) => changeNumberValue(e, 'x')} />
        </FormGroup>
        <FormGroup>
          <Label>Y</Label>
          <Input value={values.y} onChange={(e) => changeNumberValue(e, 'y')} />
        </FormGroup>
      </div>
      <div className="d-flex">
        <FormGroup>
          <Label>Width</Label>
          <Input
            value={values.width}
            onChange={(e) => changeNumberValue(e, 'width')}
          />
        </FormGroup>
        <FormGroup>
          <Label>Height</Label>
          <Input
            value={values.height}
            onChange={(e) => changeNumberValue(e, 'height')}
          />
        </FormGroup>
      </div>
      <FormGroup>
        <Label>Title</Label>
        <Input
          value={values.title}
          onChange={(e) => setFieldValue('title', e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label>Description</Label>
        <Input
          value={values.description}
          onChange={(e) => setFieldValue('description', e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <CustomInput
          id={`widget-${values.id}`}
          type="checkbox"
          label="Terminate Row"
          checked={values.terminateRow}
          onChange={(e) => {
            setFieldValue('terminateRow', e.target.checked);
          }}
        />
      </FormGroup>
    </div>
  );
};

export default Widget3Properties;
